import * as React from "react";
import StatusCell from "report/report-history-page/StatusCell";
import HasAsset from "report/report-history-page/HasAsset";
import MessageCell from "report/report-history-page/MessageCell";
import { LinkContainer } from "components/common";
import ReportRoutes from "report/ReportRoutes";
import { Button } from "components/bootstrap";
const customColumnRenderers = (reportId) => ({
  attributes: {
    status: {
      staticWidth: "matchHeader",
      renderCell: (value) => /* @__PURE__ */ React.createElement(StatusCell, { value })
    },
    message: {
      renderCell: (value) => /* @__PURE__ */ React.createElement(MessageCell, { value })
    },
    has_asset: {
      staticWidth: "matchHeader",
      renderCell: (value, history) => /* @__PURE__ */ React.createElement(HasAsset, { value, status: history.status })
    },
    recipients: {
      renderCell: (_, history) => {
        var _a;
        return history.recipients && /* @__PURE__ */ React.createElement(LinkContainer, { key: "configuration-button", to: ReportRoutes.EDIT.delivery(reportId) }, /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall" }, (_a = history.recipients) == null ? void 0 : _a.length));
      },
      staticWidth: "matchHeader",
      textAlign: "right"
    }
  }
});
export default customColumnRenderers;
